<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="voucher-template-order-main-sidebar" position="left" lockedOpen="gt-md">
        <voucher-template-main-sidebar></voucher-template-main-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24" style="max-width: 100%;">
                    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
                        <div class="example-box" *ngFor="let voucher of rows" cdkDrag>{{voucher.name}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
